import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ASSIGNMENT_DEFAULTS } from '../constants';


@Injectable()
export class AssignmentFormService {
  constructor(private readonly fb: FormBuilder) {}

  /**
   * Creates the assignment form with default values and validators
   */
  createForm(): FormGroup {
    return this.fb.group({
      zoneId: [null, Validators.required],
      targetDate: ['', Validators.required],
      generalTimeMargin: [ASSIGNMENT_DEFAULTS.GENERAL_TIME_MARGIN, Validators.required],
      exterProviderTimeMargin: [ASSIGNMENT_DEFAULTS.EXTER_PROVIDER_TIME_MARGIN, Validators.required],
      extraToppingTimeMargin: [ASSIGNMENT_DEFAULTS.EXTRA_TOPPING_TIME_MARGIN, Validators.required],
      maxDriverWalkTime: [ASSIGNMENT_DEFAULTS.MAX_DRIVER_WALK_TIME, Validators.required],
      maxDriverPublicTransportTime: [ASSIGNMENT_DEFAULTS.MAX_DRIVER_PUBLIC_TRANSPORT_TIME, Validators.required],
      sweepCarRadiusInKilometers: [ASSIGNMENT_DEFAULTS.SWEEP_CAR_RADIUS, Validators.required],
      sweepCarMaxArrivalTime: [ASSIGNMENT_DEFAULTS.SWEEP_CAR_MAX_ARRIVAL_TIME, Validators.required],
      selectedDrivers: [[]],
    });
  }

  /**
   * Validates if the form is ready to submit
   */
  isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  /**
   * Resets the form to initial state
   */
  resetForm(form: FormGroup): void {
    form.reset({
      zoneId: null,
      targetDate: '',
      generalTimeMargin: ASSIGNMENT_DEFAULTS.GENERAL_TIME_MARGIN,
      exterProviderTimeMargin: ASSIGNMENT_DEFAULTS.EXTER_PROVIDER_TIME_MARGIN,
      extraToppingTimeMargin: ASSIGNMENT_DEFAULTS.EXTRA_TOPPING_TIME_MARGIN,
      maxDriverWalkTime: ASSIGNMENT_DEFAULTS.MAX_DRIVER_WALK_TIME,
      maxDriverPublicTransportTime: ASSIGNMENT_DEFAULTS.MAX_DRIVER_PUBLIC_TRANSPORT_TIME,
      sweepCarRadiusInKilometers: ASSIGNMENT_DEFAULTS.SWEEP_CAR_RADIUS,
      sweepCarMaxArrivalTime: ASSIGNMENT_DEFAULTS.SWEEP_CAR_MAX_ARRIVAL_TIME,
      selectedDrivers: [],
    });
  }
}
